import dynaForms from '@elab/core/utils/dynaForms';

export const getSelectors = storeName => {
    const dynaSelectors = dynaForms.getSelectors(storeName);
    const isEditing = state => dynaSelectors.getStore(state).isEditing;
    const editingId = state => dynaSelectors.getStore(state).editingID;
    const addressType = state => dynaSelectors.getStore(state).addressType;
    const radioView = state => dynaSelectors.getStore(state).radioView;
    const submitEditUrl = state => dynaSelectors.getStore(state).submitEditUrl;
    const submitAddUrl = state => dynaSelectors.getStore(state).submitAddUrl;
    const submitEditMethod = state => dynaSelectors.getStore(state).submitEditMethod;
    const selectForPaymentAfterEditing = state =>
        dynaSelectors.getStore(state).selectForPaymentAfterEditing;

    return {
        ...dynaSelectors,
        isEditing,
        editingId,
        addressType,
        radioView,
        submitEditUrl,
        submitAddUrl,
        submitEditMethod,
        selectForPaymentAfterEditing,
    };
};
